import { render, staticRenderFns } from "./EduCourseCharpter.vue?vue&type=template&id=3b0408a6&scoped=true&"
import script from "./EduCourseCharpter.vue?vue&type=script&lang=js&"
export * from "./EduCourseCharpter.vue?vue&type=script&lang=js&"
import style0 from "./EduCourseCharpter.vue?vue&type=style&index=0&id=3b0408a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0408a6",
  null
  
)

export default component.exports